// export default function (data) {
//   console.log(data,'床位均价。。。。。。。。。。。');
//   return {
//     chart: {
//       renderTo: 'container',
//       type: 'column',
//       backgroundColor: 'rgba(0,0,0,0)'
//     },
//     title: {
//       text: ''
//     },
//     subtitle: {
//       text: ''
//     },
//     yAxis: {
//       gridLineWidth: 1,
//       title: {
//         text: ''
//       },
//       labels: {
//         style: {
//           color: '#ffffff'
//         }
//       }
//     },
//     xAxis: {
//       categories: data.map(item => item.largeDisplay),
//       labels: {
//         style: {
//           color: '#ffffff',
//           fontSize: '7px'
//         }
//       }
//     },
//     legend: {
//       enabled: false
//     },
//     series: [
//       {
//         name: '',
//         data: data.map(item => item.avgBedPrice)
//       }
//     ],
//     responsive: {
//       rules: [
//         {
//           condition: {
//             maxWidth: 500
//           },
//           chartOptions: {
//             legend: {
//               layout: 'horizontal',
//               align: 'center',
//               verticalAlign: 'bottom'
//             }
//           }
//         }
//       ]
//     },
//     credits: {
//       enabled: false
//     }
//   }
// }

export default function (data) {
  console.log(data, '床位均价。。。。。。。。。。。')
  const dataArr = []
  const largeDisplayArr = []
  for (let i = 0; i < data.length; i++) {
    const item = data[i]
    // 中心站点,机构
    if (item.orgPropertyType === 2 || item.orgPropertyType === 3) {
      dataArr.push(item.occupancyRate)
      largeDisplayArr.push(item.largeDisplay)
    }
  }
  return {
    colors: ['#59abff'],
    chart: {
      backgroundColor: 'rgba(0,0,0,0)',
      type: 'column',
      margin: [25, 25, 50, 25],
      options3d: {
        enabled: true,
        alpha: 10,
        beta: 15,
        depth: 70,
        viewDistance: 50,
        frame: {
          bottom: {
            size: 10
          },
          side: {
            size: 1,
            color: 'transparent'
          },
          back: {
            size: 1,
            color: 'transparent'
          }
        }
      }
    },
    title: {
      text: ''
    },
    subtitle: {
      text: ''
    },
    plotOptions: {
      column: {
        depth: 15
      }
    },
    tooltip: {
      html: true,
      formatter: function () {
        return this.x + '<br/>入住率:' + this.y + '%'
      }
    },
    xAxis: {
      categories: largeDisplayArr,
      labels: {
        style: {
          color: '#ffffff',
          fontSize: '10px'
        }
      },
      gridLineWidth: 0// 横向格线宽度
    },
    yAxis: {
      title: {
        text: null
      },
      labels: {
        style: {
          color: '#ffffff',
          fontSize: '7px'
        },
        formatter: function () {
          return this.value + '%'
        }
      },
      gridLineWidth: 0// 横向格线宽度
    },
    legend: {
      enabled: false
    },
    series: [{
      name: '入住率',
      data: dataArr
    }],
    credits: {
      enabled: false
    }
  }
}
